<template>
  <div class="view-tasklists account-lookup-view-list">
    <user-menu />
    <div class="wrapper">
      <EnterpriseAdminSidebarMenu
       :readOnly="isReadOnly"/>
      <div class="content-wrapper">
        <div class="container-wrapper center">

        <i class="fa fa-chevron-left modal-goback" @click="goToLocationWindow"></i>
          <button
            class="btn btn-red btn-md input-height-15"
            @click="printWindow()">Print</button>
            <div id="account-license">
              <div style="padding-left: 0px;width: 98%;font-size: 14px;">
                <div style="width: 100%;margin: 10px 0px 5px;border: 1px solid rgb(221, 221, 221);padding: 10px;border-radius: 4px;background-color: #FFF;">
                  <div style="padding-left: 5px;width: 100%;font-size: 14px;font-weight: 900;margin-top: 10px; margin-bottom: 10px;">
                      Purchase History
                  </div>
                  <div style="padding-left: 0px;width: 100%;font-size: 14px;" v-for="(item, index) in orderItems" :key="index">
                    <div style="width: 60%;padding-left: 5px;float: left;">{{ item.unitType }}</div>
                    <div style="width: 15%;padding-left: 5px;float: left;">${{ item.totalAmount  }}</div>
                    <div style="width: 15%;padding-left: 5px;float: left;">{{ item.expirationDate | formatExpirationDate }}</div>
                    <div style="clear: both;padding: 5px 0px 0px 0px;"></div>
                  </div>
                  <div v-if="orderItems.length === 0" style="color: #dc3545; font-weight: bold; text-align:center; margin: 10px;">No Purchase History Found</div>
                </div>
              </div>
            </div>
          </div> 
        </div>
      </div>

        <EnterpriseAdminOverlaySidebar
              :isModalVisible="isModalVisible" 
              @close="closeSidebar"
              ref="location_sidebar" 
              readOnly="" 
             />
    </div>
</template>

<script>
import axios from 'axios';
import UserMenu from '../shared/user_menu.vue';
import EnterpriseAdminSidebarMenu from '../shared/enterpriseadmin_sidebar_menu.vue';
import { store } from '../../store/store';
import EnterpriseAdminOverlaySidebar from './enterpriseadmin_overlay_sidebar.vue';
import router from '../../router/index.js';

export default {
        data() {
            return {
                orderItems: [],
                isModalVisible: false,  
                accountId: '',
                isReadOnly: false,
            }
        },
        components: {
            UserMenu,
            EnterpriseAdminSidebarMenu,
            EnterpriseAdminOverlaySidebar,
        },
        methods: {
          printWindow: function () {
            var printContents = document.getElementById('account-license').innerHTML;
            var NewWin = window.open("", "PlatformReport");
            NewWin.document.write(printContents);
            NewWin.document.close();
            NewWin.print();
            NewWin.close();
          },
          goToLocationWindow() {
            this.isModalVisible = true;
            this.$refs.location_sidebar.accountId = this.accountId;
            this.$refs.location_sidebar.selectedComponent = 'LicenseTab';
            this.$refs.location_sidebar.getLocationDetail(this.accountId);
          },
          closeSidebar() {
            router.push('/locations');
          }
        },
        created() {
            this.accountId = this.$route.params.accountId;
            axios('/enterprise-admin/account-orders/' + this.accountId,
            {
                method: 'GET'
                
            },
            )
            .then(response => {
                this.loading = false;
                this.orderItems = response.data.orderItems;
            })
            .catch(error => {
                console.log(error)
            });


            if (this.$store.state.enterprise_type === 'Readonly') {
              this.isReadOnly = true;
            } else {
              if (this.$store.state.switch_admin_enterprise_isreadonly) {
                this.isReadOnly = true;
              } else {
                this.isReadOnly = false;
              }
            }
        },
    }
</script>
<style scoped>
.modal-goback { font-size: 22px; margin: 5px 10px 0 0; cursor: pointer; }
</style>


// WEBPACK FOOTER //
// src/components/enterpriseadmin/print_account_license.vue